<template>
  <tr>
    <td :colspan="colspan">
      <div class="time-line">
        <img
          width='16'
          height='16'
          class="time-line__icon"
          src="@/assets/img/icon-time.svg"
          alt="time icon">
        <span class="time-line__time">
          {{ time }}
        </span>
        <span class="time-line__line"></span>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'EventRacesRzdRow',
  props: {
    colspan: {
      type: Number,
      default: 4,
    },
    time: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.time-line {
  display: flex;
  align-items: center;
  gap: 6px;

  &__time {
    font-weight: 500;
  }

  &__line {
    height: 1px;
    display: block;
    width: 100%;
    background-color: rgba(1, 1, 1, 0.25);
  }
}
</style>
